import React, { useContext, useEffect, useMemo, useState } from "react";
import { Backdrop, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { API } from "../../conf";
import { Context } from "../../App";
import moment from "moment";
import Step1 from "./verse-form-step1";
import Step2 from "./verse-form-step2";
import Step3 from "./verse-form-step3";
import Step4 from "./verse-form-step4";
import FinalStep from "../sections/verse-form-final-step";

export default function EditVerseForm(props) {
    const {updateConnect} = useContext(Context)
    const [load, setLoad] = useState(true)
    const [open, setOpen] = useState(false)
    const [banqueComptes, setBanqueComptes] = useState([])
    const [currentStepIndex, setCurrentStepIndex] = useState(0)
    const [pcMensuel, setPcMensuel] = useState(0) //total petite caisse des versement antérieur du mois de la date des dons sélectionnée

    const [dispoMoney, setDispoMoney] = useState([])
    const [fedVerseType, setFedVerseType] = useState(props.versement?.fedVerseType??'')
    const [fedBanque, setFedBanque] = useState(props.versement?.fedBanque??'')    
    const [take_petite_caisse, setTakePetiteCaisse] = useState(true)
    const [localVerseType, setLocalVerseType] = useState([props.versement?.petiteCaisse.length>0?'petite-caisse':'',[...props.versement?.banqueEglise?.especes, ...props.versement?.banqueEglise?.cheques].length>0?'banque':''].filter(el=>el!==''))
    const [dateDons, setDate] = useState(props.versement?.dateDons??'')
    const [dons, setDons] = useState([])
    const [fedRepartition, setFedRepartition] = useState({
        especes:props.versement?.fedRepartition?.especes?.length>0 ? props.versement?.fedRepartition?.especes : [{montant:'', count:0}], 
        cheques:props.versement?.fedRepartition?.cheques??[], 
        retrait:props.versement?.fedRepartition?.retrait?.length>0 ? props.versement?.fedRepartition?.retrait :[{montant:'', count:0}], 
        virement:props.versement?.fedRepartition?.virement ? {...props.versement.fedRepartition.virement, date:moment(props.versement.fedRepartition.virement.date??'').format('yyyy-MM-DD')} : {date:moment().format('yyyy-MM-DD'),montant:0,ref:''}
    })
    const [petiteCaisse, setPetiteCaisse] = useState(props.versement?.petiteCaisse.length>0?props.versement.petiteCaisse:[{montant:'', count:0}])
    const [banqueEglise, setBanqueEglise] = useState({especes:props.versement?.banqueEglise.especes?.length>0?props.versement.banqueEglise.especes:[{montant:'', count:0}], cheques:props.versement.banqueEglise.cheques??[]})

    const eglise = props.eglise
    useEffect(()=>{
        if (currentStepIndex===1) {
            setLoad(true)
            fetch(API.concat(`/dons/by/${JSON.stringify({eglise: eglise.number, date:dateDons})}`), {
                method:'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        setDons(json)
                        setDispoMoney([...new Set(json.map(don=>don.repartition.especes.map(es=>es.montant)).flat())]
                        .map(money=>({montant:money, count: json.reduce((tt,don)=>tt+(don.repartition.especes.find(es=>es.montant===money)?.count??0),0)}))
                        .filter(dm=>dm.count>0))
                    } 
                    setLoad(false)
                }
            })
        }
    }, [currentStepIndex])

    const fed_part = useMemo(()=>dons?.reduce((tt,current)=>tt+current.dime+Math.round((current.offrande_globale*0.4+Number.EPSILON)*100)/100+current.offrande_spe_feam.reduce((to,off)=>to+off.montant,0),0), [dons])
    const local_part = useMemo(()=>dons?.reduce((tt,current)=>tt+current.offrande_globale-Math.round((current.offrande_globale*0.4+Number.EPSILON)*100)/100+current.offrande_spe_eglise.reduce((to,off)=>to+off.montant,0),0), [dons])
    const totalFedVerse = useMemo(()=>Math.round(((fedRepartition.especes.reduce((tt,es)=>tt+Number(es.montant)*es.count,0)+fedRepartition.cheques.reduce((tt,ch)=>tt+ch.montant,0)+fedRepartition.retrait.reduce((tt,es)=>tt+Number(es.montant)*es.count,0))+Number.EPSILON)*100)/100,[fedRepartition])
    const totalPetiteCaisse = useMemo(()=>petiteCaisse.reduce((tt,es)=>tt+Number(es.montant)*es.count,0),[petiteCaisse])
    const ttPcMensuel = useMemo(()=> pcMensuel + totalPetiteCaisse, [pcMensuel, totalPetiteCaisse])
    const totalLocalRepartition = useMemo(()=>petiteCaisse.reduce((tt,es)=>tt+Number(es.montant)*es.count,0)+banqueEglise.especes.reduce((tt,es)=>tt+Number(es.montant)*es.count,0)+banqueEglise.cheques.reduce((tt,ch)=>tt+ch.montant,0),[petiteCaisse, banqueEglise])
    const restToRepart = useMemo(()=>Math.round(((dons.reduce((tt,don)=>tt+don.repartition.especes.reduce((t,es)=>t+es.montant*es.count,0)+don.repartition.cheques.reduce((t,ch)=>t+ch.montant,0),0)
        -[...banqueEglise.especes, ...petiteCaisse].reduce((tt,es)=>tt+es.montant*es.count,0)-banqueEglise.cheques.reduce((tt,ch)=>tt+ch.montant,0))+Number.EPSILON)*100)/100,[dons,petiteCaisse,banqueEglise])
     
    const steps = useMemo(() => [
        { component: <Step1 {...{isEdit:true, fedVerseType, setFedVerseType,localVerseType, take_petite_caisse, setTakePetiteCaisse, setLocalVerseType,eglise,dispoDates:[dateDons??''],dateDons,setDate}}/>, disabled:fedVerseType===""||dateDons==='', action: () => setCurrentStepIndex(old=>old+1) },
        //recapitulatif des recettes
        { component: <Step2 {...{dons, fed_part, local_part}}/>, 
            disabled:fed_part+local_part<=0, 
            action: () => { 
                if(!take_petite_caisse) setPetiteCaisse([{montant:'', count:0}]); 
                if(eglise.have_banque&&fedVerseType.includes('siege')&&!take_petite_caisse) setAllInLocaleBanqueAndRecap() 
                else setCurrentStepIndex(old=>old+(take_petite_caisse?1:2))
            } 
        },
        //alimentation petite caisse
        { component: <Step3 {...{eglise, ttPcMensuel, dons,dispoMoney, setDispoMoney, banqueComptes, fed_part, fedVerseType, take_petite_caisse, local_part, petiteCaisse, setPetiteCaisse, fedBanque, setFedBanque, setFedRepartition, fedRepartition}}/>, 
            disabled: ttPcMensuel>eglise?.limite_petite_caisse, 
            action: () => eglise?.have_banque&&!fedVerseType.includes('siege')? setAllInLocaleBanqueAndRecap() : setCurrentStepIndex(old=>old+1) 
        },
        //versement FEAM
        { component: <Step4 {...{eglise, dons, fed_part, localVerseType,fedRepartition, setFedRepartition, dispoMoney, restToRepart,petiteCaisse, setPetiteCaisse,banqueEglise, setBanqueEglise}}/>, 
            disabled:(!eglise?.have_banque)&&totalFedVerse<restToRepart, 
            action: () => eglise?.have_banque ? setAllInLocaleBanqueAndRecap() : setCurrentStepIndex(old=>old+1) 
        },
        //recapitulatif et confirmation
        { component: <FinalStep {...{eglise, fedRepartition,fedVerseType,fed_part,local_part,totalFedVerse,totalLocalRepartition,petiteCaisse,banqueEglise}} />, action: () => setOpen(true) },
    ], [eglise, ttPcMensuel, dispoMoney, fedVerseType, localVerseType, dateDons, dons, banqueComptes, fed_part, take_petite_caisse, local_part,fedBanque,fedRepartition, totalFedVerse, restToRepart, petiteCaisse, banqueEglise, totalLocalRepartition]);
    const currentStep = useMemo(() => steps[currentStepIndex], [currentStepIndex, steps]);

    function handleSubmit() {
        setLoad(true); setOpen(false);
        const versement = {fedVerseType,dateDons,feam_banque:fedBanque,dons:dons.map(d=>d.num),
            fedRepartition:{...fedRepartition,especes:fedRepartition.especes.filter(es=>es.montant!==''&&es.montant>0&&es.count>0),retrait:fedRepartition.retrait.filter(es=>es.montant>0&&es.count>0)},
            petiteCaisse:petiteCaisse.filter(es=>es.montant>0&&es.count>0),banqueEglise:{...banqueEglise, especes:banqueEglise.especes.filter(es=>es.montant>0&&es.count>0)}, eglise:eglise.number}
        fetch(API.concat(`/versements/${props.versement?._id}`), {method:'PATCH', headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            },body: JSON.stringify(versement)
        }).then(async response => {
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    console.log('json', json)
                    props.setVerses(json); 
                    props.close()
                } else {
                    setLoad(false)
                }
            }
        })
    }

    function setAllInLocaleBanqueAndRecap(){
        setLoad(true) 
        const dispoCheques = dons.map(don=>don.repartition.cheques).flat()
        const MoneyRest = dispoMoney.map(money=>({
            montant: money.montant, 
            count: money.count
                -(take_petite_caisse? (petiteCaisse.filter(es=>es.montant===money.montant).reduce((tt,es)=>tt+es.count,0)??0) : 0)
                -(fedVerseType.includes('siege') ? (fedRepartition.especes.filter(es=>es.montant===money.montant).reduce((tt,es)=>tt+es.count,0)??0) : 0)
        })).filter(m=>m.count>0)
        setBanqueEglise({especes:MoneyRest, cheques: fedVerseType.includes('siege') ? dispoCheques.filter(dc=>!fedRepartition.cheques.some(ch=>JSON.stringify(ch)===JSON.stringify(dc))) : dispoCheques})
        if(!fedVerseType.includes('siege')) setFedRepartition(old=>({...old, especes:[{montant:'', count:0}], cheques:[]}))
        setLoad(false)
        setCurrentStepIndex(old=> take_petite_caisse ? old+1 :4)
    }

    useEffect(()=>{
        if(!dateDons || dateDons==='' || !!!eglise) return
        fetch(API+'/versements/petite-caisse', {method:'POST', headers:{
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify({$expr: {$eq: [{$month: "$dateDons"}, new Date(dateDons).getMonth()+1]}, eglise: eglise.number, num: {$ne: props.versement?.num}})
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    setPcMensuel(json || 0)
                }
            }
        }).catch(err=>console.log(err))
    }, [dateDons, eglise])

    useEffect(()=>{
        fetch(API.concat(`/dons/by/${JSON.stringify({num: props.versement?.dons??[]})}`), {method:'GET', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json();
                    setDons(json)
                }
                fetch(API.concat('/comptes/federation/banque'), {method:'GET', headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }}).then(async response=>{
                    const token = response.headers.get('x-auth-token')
                    if(response.status === 401) {
                        sessionStorage.clear()
                        updateConnect(false)
                    }else {
                        if (token && token !== sessionStorage.getItem('token') && token !== '') {
                            sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                        }
                        if (response.status === 200) {
                            const json = await response.json();
                            setBanqueComptes(json)
                            setLoad(false)
                        }
                    }
                })
            }
        })
    },[])

    return(
        <Box display='flex' flex={1} flexDirection='column' style={{height:'100vh'}}>
            <Typography variant="h4" align="center" marginTop={3} marginBottom={3}>Versement {props.versement.bordereau_num}</Typography>
            <Box display='flex' flex={1} flexDirection='column' sx={{alignSelf:'center', width:'80%', border:'black 2px solid', padding:2, marginBottom:'5%', overflow:'auto'}}>
                <Box sx={{flexGrow:1, marginBottom:2}}>
                    {currentStep?.component}
                </Box>
                <Box display='flex' justifyContent='space-between' alignItems='center'>
                    <Box>{currentStepIndex>0&&<Button variant="contained" onClick={()=>setCurrentStepIndex(old=> old-1)}>précédent</Button>}</Box>
                    <Button variant="contained" disabled={currentStep.disabled??false} onClick={currentStep.action}>{currentStepIndex === steps.length - 1 ? 'Enregistrer les modifications' : 'Continuer'}</Button>
                </Box>
            </Box>
            <Dialog open={open} onClose={()=>setOpen(false)}>
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                    <Typography>Vous confirmez l'enregistrement et la transmission au siège fédéral des modifications apportées à ce versement ?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>setOpen(false)}>Annuler</Button>
                    <Button onClick={handleSubmit}>Confirmer</Button>
                </DialogActions>
            </Dialog>
            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
}